'use strict';
'use client';
import { j as e } from "../../../external/react/jsx-runtime.js";
import o from "../../../external/classnames/index.js";
import "../../../external/base-64/base64.js";
import "../../../external/js-cookie/dist/js.cookie.js";
import { formatShortDate as m } from "../../../helpers/dateUtils.js";
import { useTheme as n } from "../../Provider/index.js";
const y = ({ items: t }) => {
  const { isMosh: r, isMoshy: l } = n(), i = (a) => a === (/* @__PURE__ */ new Date()).toISOString().split("T")[0] ? "Payment today" : `By ${m(a)}`, c = "Today's dose is the only one due. Future doses will only be charged if you choose to continue your treatment on the scheduled dates.", d = "Cancel anytime, hassle-free!";
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ e.jsx("h4", { children: "What to expect" }),
    /* @__PURE__ */ e.jsx("span", { className: "p2 text-grey-400", children: "Refer to the dosage schedule to know what you can expect to pay for future doses" }),
    /* @__PURE__ */ e.jsx("div", { className: "flex flex-col md:flex-row", children: t.map((a, s) => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col grow", children: [
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "flex flex-row md:flex-col p-3 gap-4 md:gap-2 items-center md:grow",
          children: [
            /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: o(
                  "flex items-center justify-center h-[4.5rem] w-[4.5rem] border border-grey-200 rounded-full relative overflow-hidden",
                  {
                    "bg-green-light": s === 2 && r,
                    "bg-blue-extra-light": s === 2 && l
                  }
                ),
                children: [
                  /* @__PURE__ */ e.jsx(
                    "span",
                    {
                      className: o(
                        "p3 text-center",
                        {
                          "text-green-faint-dark": r,
                          "text-blue": l
                        }
                      ),
                      children: s === 0 ? "Starting dose" : "Step-up dose"
                    }
                  ),
                  (s === 0 || s === 1) && /* @__PURE__ */ e.jsxs("span", { className: "absolute bottom-0 left-0 -z-10", children: [
                    s === 0 && /* @__PURE__ */ e.jsx(h, {}),
                    s === 1 && /* @__PURE__ */ e.jsx(x, {})
                  ] })
                ]
              }
            ) }),
            /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col md:items-center md:gap-2", children: [
              /* @__PURE__ */ e.jsx(
                "h5",
                {
                  className: `${s > 0 ? "text-grey-400" : ""}`,
                  children: `$${a.discountedPrice}`
                }
              ),
              /* @__PURE__ */ e.jsx("span", { className: "p1 text-grey-400", children: i(a.date) })
            ] })
          ]
        },
        s
      ),
      s === 0 ? /* @__PURE__ */ e.jsxs("div", { className: " -mt-6 md:flex md:justify-center", children: [
        /* @__PURE__ */ e.jsx(
          "span",
          {
            className: o(
              "self-center border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 ml-10 md:ml-0",
              {
                "border-green-dark": r,
                "border-black": l
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: o(
              "p-4 rounded-2xl mt-1 md:hidden",
              {
                "bg-green-dark": r,
                "bg-black": l
              }
            ),
            children: /* @__PURE__ */ e.jsxs("span", { className: "p2 text-white", children: [
              c,
              /* @__PURE__ */ e.jsx("span", { className: "block mt-4 font-bold", children: d })
            ] })
          }
        )
      ] }) : null
    ] })) }),
    /* @__PURE__ */ e.jsx(
      "span",
      {
        className: o("p-4 rounded-2xl hidden md:flex -mt-4", {
          "bg-green-dark": r,
          "bg-black": l
        }),
        children: /* @__PURE__ */ e.jsxs("span", { className: "p2 text-white", children: [
          c,
          /* @__PURE__ */ e.jsx("span", { className: "block mt-4 font-bold", children: d })
        ] })
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "p3 text-grey-400", children: "Pricing may vary according to the prescribed dosage determined by your practitioner" })
  ] });
}, h = () => {
  const { isMosh: t } = n();
  return /* @__PURE__ */ e.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "73",
      height: "21",
      viewBox: "0 0 73 21",
      fill: "none",
      children: /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M0.666992 2.99979C12.4316 -0.361527 24.9024 -0.361527 36.667 2.99979C48.4316 6.36111 60.9024 6.36111 72.667 2.99979V20.9998H0.666992V2.99979Z",
          fill: t ? "#DAEED9" : "#E0E8FC"
        }
      )
    }
  );
}, x = () => {
  const { isMosh: t } = n();
  return /* @__PURE__ */ e.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "72",
      height: "41",
      viewBox: "0 0 72 41",
      fill: "none",
      children: /* @__PURE__ */ e.jsx(
        "path",
        {
          d: "M0 3.71429C11.4944 -1.2119 24.5056 -1.2119 36 3.71429C47.4944 8.64047 60.5056 8.64047 72 3.71429V41H0L0 3.71429Z",
          fill: t ? "#DAEED9" : "#E0E8FC"
        }
      )
    }
  );
};
export {
  y as default
};
